/**
 * The collapsed one-line preview of a compaction summary. The summary is
 * continuous prose with `\n\n` paragraph breaks (see
 * `ThreadCompactionService`'s prompt), so the first non-blank line is the
 * most representative single-line teaser. Returns `''` when the summary is
 * only whitespace — the caller renders nothing rather than an empty chevron.
 */
export function firstLineOfSummary(summary: string): string {
  for (const line of summary.split('\n')) {
    const trimmed = line.trim();
    if (trimmed.length > 0) {
      return trimmed;
    }
  }
  return '';
}
